<template>
  <div
    id="app"
    class="antialiased bg-base dark:bg-dark-base text-base dark:text-dark-base min-h-screen"
  >
    <router-view v-if="!isLoading" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useAutoLogout } from './composables/useAutoLogout'
import { auth } from './utils/auth'
import 'vue-toastification/dist/index.css'

const isLoading = ref(true)

onMounted(async () => {
  await auth.getUser()
  isLoading.value = false
})

// Initialize auto-logout
useAutoLogout()
</script>
